<script>
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";
import { HFarmCorporateModalMixin } from "../../modules/hfarm_corporate_mixins_module.js";
import TextSection from "text-section";
//import VueScript from "vue-script";

export default {
  mixins: [fandomBasicMixin, HFarmCorporateModalMixin],
  components: {
    TextSection,
    //VueScript
  },
  props: {
    customShareSlug: {
      type: String,
      default: ""
    },
    animation: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    if (this.animation) {
      Vue.nextTick(() => {
        // Animation management.
        this.registerAnimation();
      });
    }

    if (this.content.snippet) {
      Fandom.executeOnce(`script-${this.contentId}`, () => {
        const tag = document.createElement("script");
        tag.src = this.content.snippet;
        const firstScriptTag = document.getElementsByTagName("script")[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      });
    }
  },
  methods: {
    expandUrl: Fandom.expandUrl,
    exists: Fandom.exists
  },
  computed: {
    columnClasses() {
      const columnWidth = Fandom.exists(this.content.width) ? this.content.width : Fandom.retrieveFromGlobalState("one_col_text_width", 8);
      return [
        `col-lg-${columnWidth}`,
        `text-${this.content.text_align}`
      ];
    },
    componentClasses() {
      return [
        this.contentType, 
        this.content.theme ? `${this.content.theme}-theme` : ""
      ]
    },
    containerClasses() {
      return [
        Fandom.exists(this.content.background_fixed) && this.content.background_fixed && !this.isViewportMobile ? "bg-fixed" : "bg-cover-center",
        this.content.theme ? `${this.content.theme}-theme` : ""
      ];
    },
    containerStyles() {
      return {
        "min-height": this.content.height,
        "color": this.content.text_color
      };
    },
    isViewportMobile() {
      return globalState.viewport.sm || globalState.viewport.xs || globalState.viewport.md;
    }
  },
};

</script>

<template>
  <div v-easyadmin="easyadminId" :class="[componentClasses, {'inview_animate': animation}]" v-if="isContentVisibleToUser()" class="py-4" :style="{'background-color': content.background_color + ' !important'}" one-col-component>
    <span v-if="content.stripe_id" class="anchor" :id="content.stripe_id"></span>
    <!--vue-script v-if="content.snippet" :id="`#script-${contentId}`" :script="content.snippet"></vue-script-->
    <div class="container google-seo-height d-flex flex-column justify-content-center position-relative overflow-hidden" :style="containerStyles">
      <div 
        v-if="content.background_image || content.background_image_mobile"
        class="position-absolute-center bg-cover-center w-100 h-100"
        :class="{ 'inview_animate_zoom': !exists(content.image_zoom) || content.image_zoom == true }" 
        :style="{'background-image': getContentResponsiveImageURL('background_image')}"
      ></div>
      <div class="row text-align-center justify-content-center">
        <div :class="columnClasses">
          <text-section :content="content" :opt-container-content="containerContent"></text-section>
          <button
            v-if="content.modal"
            class="btn mb-4"
            :class="modalButtonClass"
            @click="showModal()"
          >
            {{ this.content.modal_title || '' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
[one-col-component] {

  /*TODO: to remove after fixed in variables file*/
  $auxiliary-navbar-height: 48px;

  .dark-theme {
    background-color: $dark;
    color: $white;
  }

  table {
    font-size: 1rem;
    font-weight: 600;
  }

}
</style>